/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { find, map } from 'lodash'
import { tracking } from 'lib/analytics'
import { openRedirectModal as openModal } from 'registry/modals/actions'
import CheckoutButton from 'cart/components/checkout-button'
import Link from 'components/link'
import MarkPurchasedModal from 'cart/components/mark-purchased-modal'
import { ReservationShape, RegistryShape } from 'cart/lib/prop-types'
import BorderedOrderWrapper from './bordered-order-wrapper'
import StoreOrderItem from './store-order-item'

@tracking((props) => {
  const { reservations, storeName: externalStoreName } = props
  const productIds = map(reservations, (r) => r.productId)
  const regItemIds = map(reservations, (r) => r.regItemId)
  return { productIds, regItemIds, externalStoreName }
})
export class BaseExternalStoreOrder extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMarkPurchasedModal: false,
    }
  }

  openMarkPurchasedModal = () => {
    this.setState({ showMarkPurchasedModal: true })
  }

  hideMarkPurchasedModal = () => {
    this.setState({ showMarkPurchasedModal: false })
  }

  renderAmazonRemoteCartStoreOrderItems = () => {
    const {
      disableBabylistOffer,
      onSetReservationToRemove,
      onSetPurchasedReservation,
      openRedirectModal,
      registry,
      reservations,
      storeName,
    } = this.props
    const { showMarkPurchasedModal } = this.state
    const checkoutClick = () => {
      openRedirectModal({
        storeDisplayName: storeName,
        reservations,
        onRedirectSuccess: this.openMarkPurchasedModal,
      })
    }

    return (
      <>
        <BorderedOrderWrapper>
          <ul className="list-bordered mbn phs mrxl-md">
            {map(reservations, (reservation) => {
              const currentOffer = find(
                reservation.regItem.offers,
                (o) => o.storeName === storeName
              )
              return (
                <li key={`${storeName}-${reservation.token}`}>
                  <StoreOrderItem
                    disableBabylistOffer={disableBabylistOffer}
                    onSetReservationToRemove={() =>
                      onSetReservationToRemove(reservation)
                    }
                    onSetPurchasedReservation={() =>
                      onSetPurchasedReservation(reservation)
                    }
                    storeName={storeName}
                    currentOffer={currentOffer}
                    reservation={reservation}
                  />
                </li>
              )
            })}
          </ul>
          <div className="mvl phs">
            <CheckoutButton
              registry={registry}
              reservations={reservations}
              storeName={storeName}
              text={`Buy on ${storeName}`}
              onCheckoutClick={checkoutClick}
            />
            <div className="text-center">
              <Link
                className="h7 mtl text-underline block"
                onClick={this.openMarkPurchasedModal}
              >
                Mark all as Purchased
              </Link>
            </div>
          </div>
        </BorderedOrderWrapper>
        {showMarkPurchasedModal ? (
          <MarkPurchasedModal
            onHide={this.hideMarkPurchasedModal}
            registry={registry}
            reservations={reservations}
            show={showMarkPurchasedModal}
            storeName={storeName}
          />
        ) : null}
      </>
    )
  }

  render() {
    const {
      disableBabylistOffer,
      openRedirectModal,
      onSetPurchasedReservation,
      onSetReservationToRemove,
      reservations,
      registry,
      storeName,
    } = this.props
    // Amazon Remote Cart for gift givers on desktop with >= 2 Amazon reservations
    if (storeName === 'Amazon' && reservations.length >= 2) {
      return this.renderAmazonRemoteCartStoreOrderItems()
    }

    // Otherwise render single click to buy ctas
    return (
      <div>
        {map(reservations, (reservation) => {
          const currentOffer = find(
            reservation.regItem.offers,
            (o) => o.storeName === storeName
          )

          const checkoutClick = () => {
            openRedirectModal({
              url: currentOffer.affiliateUrl,
              storeDisplayName: storeName,
              onRedirectSuccess: () => onSetPurchasedReservation(reservation),
            })
          }
          return (
            <BorderedOrderWrapper
              className="mbl"
              key={`${storeName}-${reservation.token}`}
            >
              <StoreOrderItem
                className="mrxl-md"
                disableBabylistOffer={disableBabylistOffer}
                onSetReservationToRemove={() =>
                  onSetReservationToRemove(reservation)
                }
                onSetPurchasedReservation={() =>
                  onSetPurchasedReservation(reservation)
                }
                storeName={storeName}
                currentOffer={currentOffer}
                reservation={reservation}
              />
              <div className="mvl phs">
                <CheckoutButton
                  registry={registry}
                  reservations={reservations}
                  storeName={storeName}
                  text={`Buy on ${storeName}`}
                  onCheckoutClick={checkoutClick}
                />
              </div>
            </BorderedOrderWrapper>
          )
        })}
      </div>
    )
  }
}

BaseExternalStoreOrder.propTypes = {
  disableBabylistOffer: PropTypes.bool,
  registry: PropTypes.shape(RegistryShape),
  reservations: PropTypes.arrayOf(PropTypes.shape(ReservationShape)),
  storeName: PropTypes.string.isRequired,
  openRedirectModal: PropTypes.func.isRequired,
  onSetReservationToRemove: PropTypes.func.isRequired,
  onSetPurchasedReservation: PropTypes.func.isRequired,
}

BaseExternalStoreOrder.defaultProps = {
  disableBabylistOffer: false,
  registry: null,
  reservations: null,
}

export const ExternalStoreOrder = connect(null, {
  openRedirectModal: openModal,
})(BaseExternalStoreOrder)
